"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import SliderArrow from "./webflow_modules/Slider/components/SliderArrow";
import SliderMask from "./webflow_modules/Slider/components/SliderMask";
import SliderNav from "./webflow_modules/Slider/components/SliderNav";
import SliderSlide from "./webflow_modules/Slider/components/SliderSlide";
import SliderWrapper from "./webflow_modules/Slider/components/SliderWrapper";
import * as _interactions from "./webflow_modules/interactions";
import { SliderNext } from "./SliderNext";
import { SliderPrev } from "./SliderPrev";

const _interactionsData = JSON.parse(
  '{"events":{"e-57":{"id":"e-57","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-29","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-58"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1706135723689},"e-58":{"id":"e-58","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-57"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"94f431fd-2c00-3080-9dc3-2c17ec68ab63","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1706135723689}},"actionLists":{"a-29":{"id":"a-29","title":"slider - hover 4","actionItemGroups":[{"actionItems":[{"id":"a-29-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"none"}}]},{"actionItems":[{"id":"a-29-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702007975249},"a-30":{"id":"a-30","title":"slider - hover - hide arrows 4","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".div-block-25","selectorGuids":["1abe4ec2-60c9-41c5-d2c1-bd3f2e916401"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702008060190}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PropertyCardVertical({
  address = "Address, City, State, Zip",
  amenitySlot = "",
  bedrooms = "1 & 2",

  linkProps = {
    href: "#",
  },

  name = "name",
  slideSlot = "",
  startingPrice = "$1,144",
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block className={"card_component"} tag={"div"}>
      <Block className={"div-block-60"} tag={"div"}>
        <Block className={"card_carousel"} tag={"div"}>
          {slideSlot ?? (
            <SliderWrapper
              animation={"slide"}
              autoMax={0}
              autoplay={false}
              className={"slider-3"}
              data-w-id={"94f431fd-2c00-3080-9dc3-2c17ec68ab63"}
              delay={4000}
              disableSwipe={false}
              duration={500}
              easing={"ease"}
              hideArrows={false}
              iconArrows={true}
              infinite={true}
              navInvert={false}
              navNumbers={false}
              navRound={true}
              navShadow={false}
              navSpacing={2}
            >
              <SliderMask>
                <SliderSlide tag={"div"}>
                  <Block className={"card_slider-image-wrapper"} tag={"div"}>
                    <Image
                      className={"card_slider-image"}
                      height={"159"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                      }
                      width={"232"}
                    />
                  </Block>
                </SliderSlide>
                <SliderSlide tag={"div"}>
                  <Block className={"card_slider-image-wrapper"} tag={"div"}>
                    <Image
                      className={"card_slider-image"}
                      height={"159"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                      }
                      width={"232"}
                    />
                  </Block>
                </SliderSlide>
                <SliderSlide tag={"div"}>
                  <Block className={"card_slider-image-wrapper"} tag={"div"}>
                    <Image
                      className={"card_slider-image"}
                      height={"159"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728684e34d594a0d7a12e4_Rectangle-112.png"
                      }
                      width={"232"}
                    />
                  </Block>
                </SliderSlide>
              </SliderMask>
              <SliderArrow className={"left-arrow-3"} dir={"left"}>
                <SliderPrev />
              </SliderArrow>
              <SliderArrow className={"right-arrow-3"} dir={"right"}>
                <SliderNext />
              </SliderArrow>
              <SliderNav className={"slide-nav-2"} />
            </SliderWrapper>
          )}
        </Block>
        <Link
          block={"inline"}
          button={false}
          className={"link-block-3"}
          options={linkProps}
        >
          <Block className={"card_content"} tag={"div"}>
            <Block tag={"div"}>
              <Block className={"card_name"} tag={"div"}>
                {name}
              </Block>
              <Block className={"card_address"} tag={"div"}>
                <Image
                  className={"vectors-wrapper-15"}
                  height={"13"}
                  loading={"lazy"}
                  src={
                    "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65728687c8a1b4c6aab7697d_Vectors-Wrapper.svg"
                  }
                  width={"9"}
                />
                <Block className={"text-size-xtiny"} tag={"div"}>
                  {address}
                </Block>
              </Block>
            </Block>
            <Block className={"card_amenities"} tag={"div"}>
              {amenitySlot ?? (
                <>
                  <Block tag={"div"} />
                  <Block tag={"div"} />
                </>
              )}
            </Block>
            <Block className={"card_details"} tag={"div"}>
              <Block className={" bedrooms"} tag={"div"}>
                <Block className={" text-39"} tag={"div"}>
                  {"STARTING AT"}
                </Block>
                <Block className={" text-size-xtiny"} tag={"div"}>
                  {startingPrice}
                </Block>
              </Block>
              <Block className={"bedrooms"} tag={"div"}>
                <Block className={"text-39"} tag={"div"}>
                  {"bedrooms"}
                </Block>
                <Block className={"text-size-xtiny"} tag={"div"}>
                  {bedrooms}
                </Block>
              </Block>
            </Block>
          </Block>
        </Link>
      </Block>
    </Block>
  );
}
